<app-go-back-header></app-go-back-header>
<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <app-afb [isOlderThan18]="false"></app-afb>
  </div>
</div>
<app-footer></app-footer>
